const TIME_ZONE = "America/New_York";

function partsAt(utcMs) {
  const dtf = new Intl.DateTimeFormat("en-US", {
    timeZone: TIME_ZONE,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  return dtf.formatToParts(new Date(utcMs)).reduce((acc, p) => {
    if (p.type !== "literal") acc[p.type] = p.value;
    return acc;
  }, {});
}

// Offset (in minutes) such that: (Eastern wall-clock digits at utcMs, read as UTC) = utcMs + offset
function zonedOffsetMinutes(utcMs) {
  const parts = partsAt(utcMs);
  const asUtc = Date.UTC(
    Number(parts.year),
    Number(parts.month) - 1,
    Number(parts.day),
    Number(parts.hour),
    Number(parts.minute),
    Number(parts.second)
  );
  return (asUtc - utcMs) / 60000;
}

// Converts a <input type="datetime-local"> value (e.g. "2026-12-20T23:59"), interpreted
// as America/New_York wall-clock time, into a UTC ISO string for storage.
export function easternInputToUtcIso(dateTimeLocalValue) {
  if (!dateTimeLocalValue) return null;

  const [datePart, timePart] = dateTimeLocalValue.split("T");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hour, minute] = timePart.split(":").map(Number);
  const localAsUtcMs = Date.UTC(year, month - 1, day, hour, minute, 0);

  let offset = zonedOffsetMinutes(localAsUtcMs);
  let targetUtcMs = localAsUtcMs - offset * 60000;

  const refinedOffset = zonedOffsetMinutes(targetUtcMs);
  if (refinedOffset !== offset) {
    targetUtcMs = localAsUtcMs - refinedOffset * 60000;
  }

  return new Date(targetUtcMs).toISOString();
}

// Converts a UTC ISO string back into a <input type="datetime-local"> value,
// displayed in America/New_York wall-clock time.
export function utcIsoToEasternInputValue(isoString) {
  if (!isoString) return "";

  const parts = partsAt(new Date(isoString).getTime());
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}
